import _ from 'topmeteo/utils/i18n';

import BaseRouteArrivalTime from '../BaseRouteArrivalTime';

import Icon from './Icon';

const Title = _('Route arrival time');

const RouteArrivalTime = ({marker}) => (
    <BaseRouteArrivalTime node={marker}>
        <Icon
            className="route-arrival-time"
            name="pin-down"
            title={Title}
        />
    </BaseRouteArrivalTime>
);

export default RouteArrivalTime;
